import Errors from "../../models/errors";

const clientFieldLabels: Record<string, string> = {
  clientId: "Cliente",
  clientCode: "Código",
  clientIsTaxPayer: "Condición de contribuyente",
  clientRuc: "RUC",
  clientDocumentNumber: "Número de documento",
  clientSocialName: "Razón social",
  clientFantasyName: "Nombre de fantasía",
  clientType: "Tipo de cliente",
  clientCountryCode: "País",
  clientHasAddress: "Posee dirección",
  clientAddress: "Dirección",
  clientHouseNumber: "Número de casa",
  clientDepartment: "Departamento",
  clientDepartmentDescription: "Descripción del departamento",
  clientDistrict: "Distrito",
  clientDistrictDescription: "Descripción del distrito",
  clientCity: "Ciudad",
  clientCityDescription: "Descripción de la ciudad",
  clientPhoneNumber: "Teléfono",
  clientEmail: "Correo electrónico",
};

interface ClientFieldErrorsProps {
  errors: Errors;
}

/** Show every client-related API validation error beside the client selector. */
const ClientFieldErrors: React.FC<ClientFieldErrorsProps> = ({ errors }) => {
  const messages = Object.entries(errors).flatMap(([field, fieldErrors]) => {
    if (!/^client[A-Z]/.test(field) || !Array.isArray(fieldErrors)) {
      return [];
    }

    const label = clientFieldLabels[field] ?? field;
    return fieldErrors.map((message) => `${label}: ${message}`);
  });

  if (messages.length === 0) return null;

  return (
    <div role="alert">
      {messages.map((message, index) => (
        <small className="d-block text-danger" key={`${message}-${index}`}>
          {message}
        </small>
      ))}
    </div>
  );
};

export default ClientFieldErrors;
